import { Icons } from '@silverfort/sf-components';
import mainImg from '../../assets/cloudAiAgentSecurityBlockPageImage.png';
import { FC } from 'react';
import { BlockPage } from '../../../../routings/pages/BlockPage/BlockPage';

export const CloudAIAgentSecurityBlockPage: FC = () => {
    const topics = [
        'Get a comprehensive inventory of AI agents operating across AWS, Azure and GCP.',
        'Gain full visibility into agent ownership & activity, including who created and who’s using each AI agent.',
        'Detect risky or misconfigured AI agents and leverage built-in remediation guidance to reduce exposure.'
    ];

    return (
        <BlockPage
            leftContent={{
                image: mainImg,
                title: 'AI Agent Security'
            }}
            rightContent={{
                accessLink: 'https://www.silverfort.com/ai-agents-security-signup',
                badgeProps: {
                    text: 'Early Availability',
                    color: 'positive',
                    icon: 'Star'
                },
                description: 'Discover and track agentic activity across your organization.',
                icon: Icons.Magic,
                title: 'Unlock AI Agent potential, securely',
                topics: topics
            }}
        />
    );
};
